export function getInstructionsTextToExport({
  projectInstructions,
  chaptersInstructions
}: {
  projectInstructions: string;
  chaptersInstructions: Record<string, string>;
}) {
  const chapterBlocks = Object.entries(chaptersInstructions).map(([key, value]) =>
    value ? `${key}\n${value}` : `${key} - No instructions`
  );
  return [`\nPROJECT INSTRUCTIONS:\n${projectInstructions}\n`, ...chapterBlocks].join(
    "\n--------------------------------\n\n"
  );
}
